import { requestAxios } from 'services';
import {
  baseStoreFactory,
  batchCollectHistoryFactory,
  pointOfServiceFactory,
} from 'factories';
import { BaseStore, BatchCollect, PointOfService } from 'types';

interface GetParams {
  storeNames: string;
}

async function get(
  params: GetParams,
  fullStory?: boolean
): Promise<PointOfService> {
  let result: any;

  try {
    const response = await requestAxios.get('stores', {
      params: {
        storeNames: params.storeNames,
        fields: fullStory && 'FULL_HISTORY',
      },
    });

    result = response.data.data[0];
  } catch (error) {
    console.error(error);
  }

  return pointOfServiceFactory(result);
}

interface PutUpdateOpeningScheduleParams {
  updatedOpeningSchedule: {
    weekday: string;
    openingTime: string;
    closingTime: string;
    isOpen: boolean;
  }[];
  store: string;
}
async function postUpdateOpeningSchedule({
  updatedOpeningSchedule,
  store,
}: PutUpdateOpeningScheduleParams) {
  let result: any;

  const params = { days: updatedOpeningSchedule };

  try {
    const response = await requestAxios.post(
      `stores/${store}/openingSchedule`,
      params
    );

    result = response;
  } catch (error) {
    console.error(error);
  }

  return result;
}

async function getBaseStore(): Promise<BaseStore> {
  let result: any;

  try {
    const response = await requestAxios.get('baseStore');

    result = response?.data;
  } catch (error) {
    console.error(error);
  }

  return baseStoreFactory(result);
}

interface GetBatchCollectsHistoryParams {
  store: string;
}

async function getBatchCollectsHistory({
  store,
}: GetBatchCollectsHistoryParams): Promise<BatchCollect[]> {
  let result: any;

  try {
    const response = await requestAxios.get(`/stores/${store}/batchCollects`);

    result = response?.data?.data;
  } catch (error) {
    console.error(error);
  }

  return batchCollectHistoryFactory(result);
}

export const storeService = {
  get,
  postUpdateOpeningSchedule,
  getBaseStore,
  getBatchCollectsHistory,
};
